import { Fetcher } from "./Fetcher";
import { LocalTag } from "@/types/front/LocalTag";
import { Component } from "@/types/front/LocalComponent";

export type TagMap = Record<string, LocalTag>;

export class TagService extends Fetcher {
  static INSTANCE: TagService = new TagService();
  static HIDDEN_TAG = "HIDDEN_TAG";

  constructor() {
    super();
  }

  orderDatasTobeShownWithTag(tags: TagMap = {}, datas: Component[] = []): Component[] {
    const selectedTags = Object.values(tags).filter(tag => tag.selected);

    const isFilterable = (t: any) =>
      t.tagDefinition === "DOMAIN_TAG" || t.tagDefinition === "NO_TAG";

    const selectedFilterable = selectedTags.filter(isFilterable);

    return datas.filter((data) => {
      const columnTags = (data.tags && data.tags.length > 0) ? data.tags : [new LocalTag()];
      const effectiveColTags = columnTags.filter(isFilterable);
      const colTagsToCheck = effectiveColTags.length > 0 ? effectiveColTags : [new LocalTag()];
      const hasHidden = columnTags.some(
        t => t.tagDefinition === "HIDDEN_TAG",
      );
      if (hasHidden) return false;

      if (selectedFilterable.length === 1 && colTagsToCheck.length === 1 && colTagsToCheck[0].localName === "no_tag") return true;
      else {
        return colTagsToCheck.some(colTag =>
          selectedFilterable.some(selTag => selTag.tagName === colTag.tagName),
        );
      }
    });
  }

  toBeShown(tags: TagMap = {}, datas: Record<string, Component> = {}): Component[] {
    const sortedDatas: Component[] = Object.values(datas).sort((a, b) => {
      if (!a.order) return 1;
      if (a.order && b.order) {
        if (a.order === b.order) return 0;
        return a.order > b.order ? 1 : -1;
      }
      return -1;
    });

    if (!tags || !Object.keys(tags).length || Object.keys(tags).length === 1) {
      return sortedDatas;
    }
    return this.orderDatasTobeShownWithTag(tags, sortedDatas);
  }

  toBeShownDataColumns(tags: TagMap = {}, datas: Record<string, Component> = {}): Component[] {
    const sortedDatas: Component[] = Object.values(datas).sort((a, b) => {
      if (!a.order) return -1;
      if (a.order && b.order) {
        if (a.order === b.order) return 0;
        return a.order > b.order ? -1 : 1;
      }
      return 1;
    });

    return this.orderDatasTobeShownWithTag(tags, sortedDatas);
  }

  sizeCollapseTags(tags: TagMap = {}): void {
    const tagCollapse = document.getElementById("tagsCollapse");
    if (!tagCollapse) return;
    if (Object.keys(tags).length <= 4) {
      tagCollapse.className = "column is-offset-one-third is-one-third";
    }
    else if (Object.keys(tags).length <= 8) {
      tagCollapse.className = "column is-offset-one-fifth is-three-fifths";
    }
    else {
      tagCollapse.className = "column";
    }
  }
}
